// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/services/web/tos.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "api.devplan.services.web.tos";

/** POST /api/v1/tos/accept request */
export interface AcceptTosRequest {
  /** Required: "dialog" (from modal) or "unset" (fallback) */
  acceptMethod: string;
}

/** POST /api/v1/tos/accept response */
export interface AcceptTosResponse {
  success: boolean;
  /** ISO timestamp */
  acceptedAt: string;
}

/** GET /api/v1/tos/status response */
export interface GetTosStatusResponse {
  currentTosVersionId: number;
  hasAccepted: boolean;
  /** ISO timestamp if accepted */
  acceptedAt?: string | undefined;
}

/** Error payload for TOS enforcement (403 response body) */
export interface TosNotAcceptedError {
  /** "tos_not_accepted" */
  errorCode: string;
  currentTosVersionId: number;
  /** Human-readable message */
  message: string;
}

function createBaseAcceptTosRequest(): AcceptTosRequest {
  return { acceptMethod: "" };
}

export const AcceptTosRequest: MessageFns<AcceptTosRequest> = {
  encode(message: AcceptTosRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.acceptMethod !== "") {
      writer.uint32(10).string(message.acceptMethod);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcceptTosRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcceptTosRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.acceptMethod = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AcceptTosRequest {
    return {
      acceptMethod: isSet(object.acceptMethod)
        ? globalThis.String(object.acceptMethod)
        : isSet(object.accept_method)
        ? globalThis.String(object.accept_method)
        : "",
    };
  },

  toJSON(message: AcceptTosRequest): unknown {
    const obj: any = {};
    if (message.acceptMethod !== "") {
      obj.acceptMethod = message.acceptMethod;
    }
    return obj;
  },

  create(base?: DeepPartial<AcceptTosRequest>): AcceptTosRequest {
    return AcceptTosRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AcceptTosRequest>): AcceptTosRequest {
    const message = createBaseAcceptTosRequest();
    message.acceptMethod = object.acceptMethod ?? "";
    return message;
  },
};

function createBaseAcceptTosResponse(): AcceptTosResponse {
  return { success: false, acceptedAt: "" };
}

export const AcceptTosResponse: MessageFns<AcceptTosResponse> = {
  encode(message: AcceptTosResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success);
    }
    if (message.acceptedAt !== "") {
      writer.uint32(18).string(message.acceptedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AcceptTosResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAcceptTosResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.success = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.acceptedAt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AcceptTosResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      acceptedAt: isSet(object.acceptedAt)
        ? globalThis.String(object.acceptedAt)
        : isSet(object.accepted_at)
        ? globalThis.String(object.accepted_at)
        : "",
    };
  },

  toJSON(message: AcceptTosResponse): unknown {
    const obj: any = {};
    if (message.success !== false) {
      obj.success = message.success;
    }
    if (message.acceptedAt !== "") {
      obj.acceptedAt = message.acceptedAt;
    }
    return obj;
  },

  create(base?: DeepPartial<AcceptTosResponse>): AcceptTosResponse {
    return AcceptTosResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AcceptTosResponse>): AcceptTosResponse {
    const message = createBaseAcceptTosResponse();
    message.success = object.success ?? false;
    message.acceptedAt = object.acceptedAt ?? "";
    return message;
  },
};

function createBaseGetTosStatusResponse(): GetTosStatusResponse {
  return { currentTosVersionId: 0, hasAccepted: false, acceptedAt: undefined };
}

export const GetTosStatusResponse: MessageFns<GetTosStatusResponse> = {
  encode(message: GetTosStatusResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.currentTosVersionId !== 0) {
      writer.uint32(8).int32(message.currentTosVersionId);
    }
    if (message.hasAccepted !== false) {
      writer.uint32(16).bool(message.hasAccepted);
    }
    if (message.acceptedAt !== undefined) {
      writer.uint32(26).string(message.acceptedAt);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetTosStatusResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetTosStatusResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.currentTosVersionId = reader.int32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.hasAccepted = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.acceptedAt = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetTosStatusResponse {
    return {
      currentTosVersionId: isSet(object.currentTosVersionId)
        ? globalThis.Number(object.currentTosVersionId)
        : isSet(object.current_tos_version_id)
        ? globalThis.Number(object.current_tos_version_id)
        : 0,
      hasAccepted: isSet(object.hasAccepted)
        ? globalThis.Boolean(object.hasAccepted)
        : isSet(object.has_accepted)
        ? globalThis.Boolean(object.has_accepted)
        : false,
      acceptedAt: isSet(object.acceptedAt)
        ? globalThis.String(object.acceptedAt)
        : isSet(object.accepted_at)
        ? globalThis.String(object.accepted_at)
        : undefined,
    };
  },

  toJSON(message: GetTosStatusResponse): unknown {
    const obj: any = {};
    if (message.currentTosVersionId !== 0) {
      obj.currentTosVersionId = Math.round(message.currentTosVersionId);
    }
    if (message.hasAccepted !== false) {
      obj.hasAccepted = message.hasAccepted;
    }
    if (message.acceptedAt !== undefined) {
      obj.acceptedAt = message.acceptedAt;
    }
    return obj;
  },

  create(base?: DeepPartial<GetTosStatusResponse>): GetTosStatusResponse {
    return GetTosStatusResponse.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<GetTosStatusResponse>): GetTosStatusResponse {
    const message = createBaseGetTosStatusResponse();
    message.currentTosVersionId = object.currentTosVersionId ?? 0;
    message.hasAccepted = object.hasAccepted ?? false;
    message.acceptedAt = object.acceptedAt ?? undefined;
    return message;
  },
};

function createBaseTosNotAcceptedError(): TosNotAcceptedError {
  return { errorCode: "", currentTosVersionId: 0, message: "" };
}

export const TosNotAcceptedError: MessageFns<TosNotAcceptedError> = {
  encode(message: TosNotAcceptedError, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.errorCode !== "") {
      writer.uint32(10).string(message.errorCode);
    }
    if (message.currentTosVersionId !== 0) {
      writer.uint32(16).int32(message.currentTosVersionId);
    }
    if (message.message !== "") {
      writer.uint32(26).string(message.message);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TosNotAcceptedError {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTosNotAcceptedError();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.errorCode = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.currentTosVersionId = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TosNotAcceptedError {
    return {
      errorCode: isSet(object.errorCode)
        ? globalThis.String(object.errorCode)
        : isSet(object.error_code)
        ? globalThis.String(object.error_code)
        : "",
      currentTosVersionId: isSet(object.currentTosVersionId)
        ? globalThis.Number(object.currentTosVersionId)
        : isSet(object.current_tos_version_id)
        ? globalThis.Number(object.current_tos_version_id)
        : 0,
      message: isSet(object.message) ? globalThis.String(object.message) : "",
    };
  },

  toJSON(message: TosNotAcceptedError): unknown {
    const obj: any = {};
    if (message.errorCode !== "") {
      obj.errorCode = message.errorCode;
    }
    if (message.currentTosVersionId !== 0) {
      obj.currentTosVersionId = Math.round(message.currentTosVersionId);
    }
    if (message.message !== "") {
      obj.message = message.message;
    }
    return obj;
  },

  create(base?: DeepPartial<TosNotAcceptedError>): TosNotAcceptedError {
    return TosNotAcceptedError.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<TosNotAcceptedError>): TosNotAcceptedError {
    const message = createBaseTosNotAcceptedError();
    message.errorCode = object.errorCode ?? "";
    message.currentTosVersionId = object.currentTosVersionId ?? 0;
    message.message = object.message ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
